// import React, { useEffect, useState } from 'react'
// import { Menu, Drawer, Button } from 'antd'
// import { MenuOutlined } from '@ant-design/icons'
// import { NavLink } from 'react-router-dom'
// import { HighlightMasterFindAll } from '../../ApiFile'
// import axios from 'axios'

// const Navbar = () => {
//   const [visible, setVisible] = useState(false)

//   const [texts, setTexts] = useState([])

//   useEffect(() => {
//     // Fetch the data from the API
//     axios
//       .get(HighlightMasterFindAll)
//       .then((response) => {
//         const fetchedTexts = response.data.map((item) => item.admin_text)
//         setTexts(fetchedTexts)
//       })
//       .catch((error) => {
//         console.error('Error fetching data:', error)
//       })
//   }, [])

//   useEffect(() => {
//     const handleScroll = () => {
//       const navbar = document.querySelector('.navbar')
//       if (window.scrollY > 100) {
//         navbar.classList.add('fixed-top', 'fixed-background')
//       } else {
//         navbar.classList.remove('fixed-top', 'fixed-background')
//       }
//     }

//     window.addEventListener('scroll', handleScroll)

//     return () => {
//       window.removeEventListener('scroll', handleScroll)
//     }
//   }, [])

//   const showDrawer = () => {
//     setVisible(true)
//   }

//   const onClose = () => {
//     setVisible(false)
//   }

//   const marqueeStyle = {
//     backgroundColor: 'rgb(238, 21, 21)',
//     padding: '2px',
//     fontSize: '20px',
//     fontWeight: 'bold',
//     display: 'inline-block',
//     color: 'yellow',
//     textShadow: '2px 2px 4px #000000',
//     animation: 'blink  step-start infinite',
//   }
//   return (
//     <>
//       <div className="container-fluid bg-primary px-5 d-none d-lg-block">
//         <div className="row gx-0">
//           <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
//             <div
//               className="d-inline-flex align-items-center"
//               style={{ height: '45px' }}
//             >
//               <a
//                 className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
//                 href="https://www.facebook.com"
//               >
//                 <i className="fab fa-facebook-f fw-normal" />
//               </a>
//               <a
//                 className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2"
//                 href="https://www.instagram.com"
//               >
//                 <i className="fab fa-instagram fw-normal" />
//               </a>
//               <a
//                 className="btn btn-sm btn-outline-light btn-sm-square rounded-circle"
//                 href="https://www.youtube.com"
//               >
//                 <i className="fab fa-youtube fw-normal" />
//               </a>
//             </div>
//           </div>
//           <div className="col-lg-4 text-center text-lg-end">
//             <div
//               className="d-inline-flex align-items-center"
//               style={{ height: '45px', marginLeft: '-200px' }}
//             >
//               <a href="mailto:jainboardingsangli@gmail.com">
//                 <small className="me-3 text-light">
//                   <i className="fa fa-envelope me-2" />
//                   jainboardingsangli@gmail.com
//                 </small>
//               </a>
//               <a href="tel:02332623206">
//                 <small className="me-3 text-light">
//                   <i className="fa fa-phone me-2" />
//                   0233 2623206
//                 </small>
//               </a>
//               <div className="nav-item dropdown">
//                 <NavLink
//                   to="/StudentLogin"
//                   className="nav-link dropdown-toggle"
//                   style={{ color: 'white' }}
//                   data-bs-toggle="dropdown"
//                   isActive={() => window.location.pathname === '/StudentLogin'}
//                 >
//                   <i className="fa fa-user me-2" />
//                   Student Login
//                 </NavLink>
//                 <div
//                   className="dropdown-menu m-0"
//                   style={{ padding: '10px', width: '200px', height: '160px' }}
//                 >
//                   <h6>Hello Users,</h6>
//                   <span>Please Login your Account here</span>
//                   <br />
//                   <br />
//                   <button
//                     className="btn btn-primary"
//                     style={{ marginLeft: '50px' }}
//                   >
//                     Login
//                   </button>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         style={{
//           display: 'flex',
//           alignItems: 'center',
//           justifyContent: 'center',
//           backgroundColor: 'rgb(238, 21, 21)',
//         }}
//         sm={12}
//         md={12}
//       >
//         <marquee>
//           <span style={marqueeStyle}>{texts.join(' | ')}</span>
//         </marquee>
//       </div>

//       <div className="container-fluid position-relative p-0">
//         <nav className="navbar navbar-expand-lg navbar-light px-1 px-lg-5 py-3 py-lg-0">
//           <a href="/" className="navbar-brand p-0">
//               <img src="assets/img/jain logo.png" alt="Logo" />
//           </a>
//           <Button
//             className="navbar-toggler d-lg-none mt-3 mt-lg-0"
//             type="button"
//             onClick={showDrawer}
//           >
//             <MenuOutlined />
//           </Button>
//           <div
//             className="collapse navbar-collapse d-none d-lg-block"
//             id="navbarCollapse"
//             style={{ display: 'flex', justifyContent: 'center',border:"1px solid red", }}
//           >
//             <Menu mode="horizontal">
//               <Menu.Item key="1">
//                 <NavLink to="/Home">Home</NavLink>
//               </Menu.Item>
//               <Menu.Item key="2">
//                 <NavLink to="/About">About</NavLink>
//               </Menu.Item>
//               <Menu.Item key="3">
//                 <NavLink to="/Services">Services</NavLink>
//               </Menu.Item>
//               <Menu.Item key="4">
//                 <NavLink to="/StudentLogin">Hostel</NavLink>
//               </Menu.Item>
//               <Menu.SubMenu key="sub1" title="Gallery">
//                 <Menu.Item key="5">
//                   <NavLink to="/Gallery">Photo</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="6">
//                   <NavLink to="/Boardofdir">Board of Directors</NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//               <Menu.Item key="7">
//                 <NavLink to="/Alumini">Alumni</NavLink>
//               </Menu.Item>
//               <Menu.Item key="8">
//                 <NavLink to="https://registration.jainboardingsangli.com">
//                   VadhuVar
//                 </NavLink>
//               </Menu.Item>
//               <Menu.Item key="9">
//                 <NavLink to="/Donation">Donation</NavLink>
//               </Menu.Item>
//               <Menu.Item key="10">
//                 <NavLink to="/Contact">Contact</NavLink>
//               </Menu.Item>

//               <Menu.SubMenu key="sub2" title="Admin">
//                 <Menu.Item key="11">
//                   <NavLink to="/AdminLogin">Main</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="12">
//                   <NavLink to="/Superintendent">Superintendent</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="13">
//                   <NavLink to="/OfficeAttendant">Office Attendant</NavLink>
//                 </Menu.Item>

//                 <Menu.Item key="14">
//                   <NavLink to="/MessAttendant">Mess Attendant</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="15">
//                   <NavLink to="https://registration.jainboardingsangli.com/#/admin">
//                     Vadhuvar Admin
//                   </NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//             </Menu>
//           </div>
          
//           <Drawer
//             title="Menu"
//             placement="left"
//             onClose={onClose}
//             visible={visible}
//             className="d-lg-none"
//           >
//             <Menu mode="inline">
//               <Menu.Item key="1">
//                 <NavLink to="/Home">Home</NavLink>
//               </Menu.Item>
//               <Menu.Item key="2">
//                 <NavLink to="/About">About</NavLink>
//               </Menu.Item>
//               <Menu.Item key="3">
//                 <NavLink to="/Services">Services</NavLink>
//               </Menu.Item>
//               <Menu.Item key="4">
//                 <NavLink to="/StudentLogin">Hostel</NavLink>
//               </Menu.Item>
//               <Menu.SubMenu key="sub1" title="Gallery">
//                 <Menu.Item key="5">
//                   <NavLink to="/Gallery">Photo</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="6">
//                   <NavLink to="/Boardofdir">Board of Directors</NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//               <Menu.Item key="7">
//                 <NavLink to="/Alumini">Alumni</NavLink>
//               </Menu.Item>
//               <Menu.Item key="8">
//                 <NavLink to="https://registration.jainboardingsangli.com">
//                   VadhuVar
//                 </NavLink>
//               </Menu.Item>
//               <Menu.Item key="9">
//                 <NavLink to="/Donation">Donation</NavLink>
//               </Menu.Item>
//               <Menu.Item key="10">
//                 <NavLink to="/Contact">Contact</NavLink>
//               </Menu.Item>
//               <Menu.SubMenu key="sub2" title="Admin">
//                 <Menu.Item key="11">
//                   <NavLink to="/AdminLogin">Main</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="12">
//                   <NavLink to="/Superintendent">Superintendent</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="13">
//                   <NavLink to="/OfficeAttendant">Office Attendant</NavLink>
//                 </Menu.Item>

//                 <Menu.Item key="14">
//                   <NavLink to="/MessAttendant">Mess Attendant</NavLink>
//                 </Menu.Item>
//                 <Menu.Item key="15">
//                   <NavLink to="https://registration.jainboardingsangli.com/#/admin">
//                     Vadhuvar Admin
//                   </NavLink>
//                 </Menu.Item>
//               </Menu.SubMenu>
//             </Menu>
//           </Drawer>
//         </nav>
//       </div>
//     </>
//   )
// }

// const blinkKeyframes = `
// @keyframes blink {
//   50% { opacity: 0; }
// }
// `

// // Inject the keyframes into the document head
// const styleSheet = document.styleSheets[0]
// styleSheet.insertRule(blinkKeyframes, styleSheet.cssRules.length)

// export default Navbar


import React, { useEffect, useState } from 'react'
import { Menu, Drawer, Button, Typography, Grid } from 'antd'
import { MenuOutlined } from '@ant-design/icons'
import { NavLink, useLocation } from 'react-router-dom'
import axios from 'axios'
import { HighlightMasterFindAll } from '../../ApiFile'

const { Text } = Typography
const { useBreakpoint } = Grid

const Navbar = () => {
  const [visible, setVisible] = useState(false)
  const [texts, setTexts] = useState([])
  const location = useLocation()
  const screens = useBreakpoint()

  // Fetch marquee text
  useEffect(() => {
    axios
      .get(HighlightMasterFindAll)
      .then((response) => {
        const fetchedTexts = response.data.map((item) => item.admin_text)
        setTexts(fetchedTexts)
      })
      .catch((error) => console.error('Error fetching data:', error))
  }, [])

  const menuItems = [
    { key: '1', label: <NavLink to="/Home">Home</NavLink> },
    { key: '2', label: <NavLink to="/About">About</NavLink> },
    { key: '3', label: <NavLink to="/Services">Services</NavLink> },
    { key: '4', label: <NavLink to="/StudentLogin">Hostel</NavLink> },
    {
      key: 'sub1',
      label: 'Gallery',
      children: [
        { key: '5', label: <NavLink to="/Gallery">Photo</NavLink> },
        { key: '6', label: <NavLink to="/Boardofdir">Board of Directors</NavLink> },
      ],
    },
    { key: '7', label: <NavLink to="/Alumini">Alumni</NavLink> },
    {
      key: '8',
      label: (
        <a href="https://registration.jainboardingsangli.com" target="_blank" rel="noopener noreferrer">
          VadhuVar
        </a>
      ),
    },
    { key: '9', label: <NavLink to="/Donation">Donation</NavLink> },
    { key: '10', label: <NavLink to="/Contact">Contact</NavLink> },
    {
      key: 'sub2',
      label: 'Admin',
      children: [
        { key: '11', label: <NavLink to="/AdminLogin">Main</NavLink> },
        { key: '12', label: <NavLink to="/Superintendent">Superintendent</NavLink> },
        { key: '13', label: <NavLink to="/OfficeAttendant">Office Attendant</NavLink> },
        { key: '14', label: <NavLink to="/MessAttendant">Mess Attendant</NavLink> },
        {
          key: '15',
          label: (
            <a href="https://registration.jainboardingsangli.com/#/admin" target="_blank" rel="noopener noreferrer">
              Vadhuvar Admin
            </a>
          ),
        },
      ],
    },
  ]

  const showDrawer = () => setVisible(true)
  const onClose = () => setVisible(false)

  return (
    <>
      {/* 🔴 Marquee Section */}
      <div
        style={{
          backgroundColor: '#d63031',
          color: 'yellow',
          padding: '5px 0',
          fontWeight: 600,
          fontSize: '1rem',
          overflow: 'hidden',
          position: 'relative',
        }}
      >
        <div
          style={{
            whiteSpace: 'nowrap',
            display: 'inline-block',
            animation: 'scrollLeft 35s linear infinite',
          }}
        >
          {texts.join(' | ')}
        </div>
      </div>

      {/* 🔵 Navbar Section */}
      <header
        className="shadow-md sticky top-0 z-50"
        style={{
          background: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: '0.6rem 2rem',
          borderBottom: '1px solid #f0f0f0',
        }}
      >
        {/* Logo */}
        <NavLink to="/" className="flex items-center gap-2">
          <img
            src="/assets/img/jain logo.png"
            alt="Logo"
            style={{ height: '55px', width: 'auto' }}
          />
        </NavLink>

        {/* Desktop Menu (visible on md and up) */}                                
        {screens.md && (
          <Menu
            mode="horizontal"
            selectedKeys={[location.pathname]}
            items={menuItems}
            style={{
              borderBottom: 'none',
              fontSize: '16px',
              fontWeight: 500,
            }}
          />
        )}

        {/* Mobile Menu Button (only on small screens) */}
        {!screens.md && (
          <Button
            type="text"
            icon={<MenuOutlined style={{ fontSize: 24 }} />}
            onClick={showDrawer}
          />
        )}
      </header>

      {/* Drawer (rendered only for mobile screens) */}
      {!screens.md && (
        <Drawer
          title={<Text strong>Menu</Text>}
          placement="left"
          onClose={onClose}
          open={visible}
          width={250}
          bodyStyle={{ padding: 0 }}
        >
          <Menu
            mode="inline"
            items={menuItems}
            selectedKeys={[location.pathname]}
            style={{ border: 'none', fontSize: '16px' }}
          />
        </Drawer>
      )}

      {/* Keyframes for marquee animation */}
      <style>{`
        @keyframes scrollLeft {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
    </>
  )
}

export default Navbar

